module.exports = __webpack_public_path__ + "img/insurance_alt.22b7444.svg";